import React from "react";
import "./BIDButton.css";

/**
 *
 * @param {string} text Text inside the button
 * @param {string} type Color: dark, light or null (default)
 * @param {string} size Size: small, medium or large
 * @param {function} onClick Callback function for when button is clicked
 * @returns Button component
 */

export default function BIDButton({ text, type, size, onClick }) {
  const getColorClass = () => {
    switch (type) {
      case "dark":
        return "dark-blue";
      case "light":
        return "light-blue";
      default:
        return "default-colors";
    }
  };

  return (
    <div
      className={"BIDButton " + getColorClass() + " " + (size ?? "large")}
      onClick={onClick}
    >
      {text}
    </div>
  );
}
